import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import BookingForm from "./BookingForm";
import { useLanguage } from "@/context/LanguageContext";

export default function BookingModal({ open, onOpenChange, preselectedCaseType, preselectedAttorney }) {
  const { t } = useLanguage();
  const bk = t("booking");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="booking-modal" className="max-w-2xl max-h-[90vh] overflow-y-auto bg-white rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-extrabold text-[#1a1a2e] tracking-[-0.02em]">{bk.title}</DialogTitle>
          <DialogDescription className="text-[#4a4540]">{bk.description}</DialogDescription>
        </DialogHeader>
        <BookingForm
          key={`${preselectedCaseType}-${preselectedAttorney}`}
          preselectedCaseType={preselectedCaseType}
          preselectedAttorney={preselectedAttorney}
        />
      </DialogContent>
    </Dialog>
  );
}
